module.exports = "https://web-assets-production.autolist.com/_next/static/images/car-value-demo_es-9721ea8237fa10b7fbf3ca252c2fd561.png";